exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3aBuer4A7wGcAJ{background:#fdfae5;padding:16px 8px 16px 62px;display:flex}.aiWGh0bzq-SYnK{display:block}._3c-xJOmlDuhkfX{flex:1}._2JW20aTsv0TWb9{background:rgba(9,30,66,.04);box-sizing:border-box;border-radius:3px;display:inline-block;line-height:28px;padding:6px 12px;text-decoration:none;position:relative}._2JW20aTsv0TWb9:focus,._2JW20aTsv0TWb9:hover{background:rgba(9,30,66,.13)}._30AYkCRZSo3zUF{background:transparent;display:flex;align-items:center;justify-content:center;width:44px}._30AYkCRZSo3zUF:focus,._30AYkCRZSo3zUF:hover{background:rgba(9,30,66,.04)}._2JW20aTsv0TWb9,._30AYkCRZSo3zUF{margin:0 0 0 8px;height:44px;border:2px solid transparent}._2JW20aTsv0TWb9:focus,._30AYkCRZSo3zUF:focus{outline:0;border-color:#0079bf}", ""]);

// exports
exports.locals = {
	"banner": "_3aBuer4A7wGcAJ",
	"headline": "aiWGh0bzq-SYnK",
	"content": "_3c-xJOmlDuhkfX",
	"learnMore": "_2JW20aTsv0TWb9",
	"close": "_30AYkCRZSo3zUF"
};